const sdata = [
  {
    src: "https://wallpapercave.com/wp/wp4056410.jpg",
    title: "A Netflix Original Series",
    sname: "DARK",
    link: "https://www.netflix.com/in/title/80100172",
  },

  {
    src: "https://cdn.vox-cdn.com/thumbor/cEosW8y7BkgF2F6FktX0rhOzDMs=/0x0:810x1200/920x613/filters:focal(337x847:465x975):format(webp)/cdn.vox-cdn.com/uploads/chorus_image/image/55660157/strangerthings.0.jpg",
    title: "A Netflix Original Series",
    sname: "STRANGER THINGS",
    link: "https://www.netflix.com/in/title/80057281",
  },

  {
    src: " https://rukminim1.flixcart.com/image/416/416/kdga1zk0/poster/2/p/i/large-breakingbad04-breaking-bad-poster-breaking-bad-series-original-imafuc2fvfjyackz.jpeg?q=70",
    title: "A Netflix Orginal Series",
    sname: "BREAKING BAD",
    link: "https://www.netflix.com/in/title/70143836",
  },

  {
    src: "https://tvline.com/wp-content/uploads/2021/08/lucifer-final-season-6-poster.jpg",
    title: "A Netflix Original Series",
    sname: "LUCIFER",
    link: "https://www.netflix.com/in/title/80057918",
  },

  {
    src: "https://m.media-amazon.com/images/I/51azqAVgmzL._AC_.jpg",
    title: "A Netflix Original Series",
    sname: "WALKING DEAD",
    link: "https://www.netflix.com/in/title/70177057",
  },

  {
    src: "https://m.media-amazon.com/images/I/61boFr6SYZL._SL1000_.jpg",
    title: "A Netflix Original Series",
    sname: "MONEY HEIST",
    link: "https://www.netflix.com/in/title/80192098",
  },
  {
    src: "https://assets.fontsinuse.com/static/use-media-items/67/66965/full-850x1005/5ae7e9f6/mindhunter.jpeg",
    title: "A Netflix Original Series",
    sname: "MIND HUNTERS",
    link: "https://www.netflix.com/in/title/80114855",
  },
  {
    src: "https://img.indiaforums.com/article/1040x780/16/0043-netflix-drops-the-trailer-of-taj-mahal-1989.jpg",
    title: "A Netflix Original Series",
    sname: "TAJ MAHAL 1989",
    link: "https://www.netflix.com/in/title/81183493",
  },
  {
    src: "https://cdnb.artstation.com/p/assets/images/images/020/390/111/medium/suvam-fellow-sacred-games.jpg?1567595849",
    title: "A Netflix Original Series",
    sname: "SACRED GAMES",
    link: "https://www.netflix.com/in/title/80115328",
  },
];

export default sdata;
